export interface VacancyFieldDetail {
  label: string;
  value: string;
}

export interface VacancyFieldStatus {
  key: string;
  label: string;
  status: 'pending' | 'filled' | 'no_data';
  value?: string;
  details?: VacancyFieldDetail[];
}

export interface ChatMessage {
  id: string;
  type: 'user' | 'assistant' | 'thinking' | 'progress' | 'done' | 'overview' | 'requirements';
  text?: string;
  fields?: VacancyFieldStatus[];
  filledCount?: number;
  skippedCount?: number;
  requirements?: {
    required: RequirementItem[];
    optional: RequirementItem[];
  };
}

export interface RequirementItem {
  id: string;
  text: string;
  weight?: number; // 0-10, default: 7 for required, 3 for optional
}

export const VACANCY_FIELDS: VacancyFieldStatus[] = [
  { key: 'description', label: 'Описание вакансии', status: 'pending' },
  { key: 'companyDescription', label: 'О компании и команде', status: 'pending' },
  { key: 'experience', label: 'Опыт работы', status: 'pending' },
  { key: 'salary', label: 'Условия и зарплата', status: 'pending' },
  { key: 'workFormat', label: 'Формат работы', status: 'pending' },
];
